import { Module } from '@nestjs/common';
import { GastosModule } from 'src/gastos/gastos.module';
import { OrdenesCompraModule } from 'src/ordenes-compra/ordenes-compra.module';
import { PrismaModule } from 'src/prisma/prisma.module';
import { RequisicionesController } from './requisiciones.controller';
import { RequisicionesService } from './requisiciones.service';

@Module({
  imports: [PrismaModule, OrdenesCompraModule, GastosModule],
  controllers: [RequisicionesController],
  providers: [RequisicionesService],
  exports: [RequisicionesService],
})
export class RequisicionesModule {}
